<template>
  <div class="myApi">
    <div class="title">我的API</div>
    <div class="box" v-if="list.length > 0">
      <div
        class="item"
        v-for="item in list"
        :key="item.interfaceId"
        @click="$router.push(`/apiMargetDetail/${item.interfaceId}`)"
      >
        <img :src="item.imgUrl" alt="" class="item-img" />
        <div>
          <div class="item-name item-bottom">{{ item.name }}</div>
          <div v-if="item.state === 2">
            <span style="color: red; font-weight: 700;font-size: 18px;"
              >暂停使用,联系管理员或购买该接口可恢复正常</span
            >
          </div>
          <div v-else>
            <div class="item-times item-bottom">
              剩余次数：<span style="color: red"
                >{{ item.avaliableTimes }}次</span
              >, 总次数：<span style="color: green">{{ item.allTimes }}次</span
              >, 已使用次数：<span style="color: #c7cece"
                >{{ item.useTimes }}次</span
              >
            </div>
            <div class="item-bottom">
              过期时间：<span style="color: red">{{ item.endTimeStr }}</span>
            </div>
            <div class="item-bottom">
              调用频次：每{{ convertlimitType(item.limitType)
              }}{{ item.limitRate }}次
            </div>
          </div>
        </div>
        <!-- <div class="item-pay">再次购买</div> -->
      </div>
    </div>
    <div v-else class="noData">
      <img :src="emptyUrl" alt="" class="url" />
      <span class="content">暂无数据</span>
    </div>
  </div>
</template>

<script>
import { myApi } from '@/api/common'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      list: {}
    }
  },
  computed: {
    ...mapState(['emptyUrl'])
  },
  methods: {
    convertlimitType (limitType) {
      if (limitType === 1) {
        return '秒'
      }
      if (limitType === 2) {
        return '分钟'
      }
      if (limitType === 3) {
        return '小时'
      }
      if (limitType === 4) {
        return '天'
      }
    }
  },
  async created () {
    const result = await myApi()
    this.list = result.data
  }
}
</script>

<style lang="less" scoped>
.myApi {
  width: 100%;
  padding: 30px 40px;
  .title {
    color: #333;
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 22px;
  }
  .noData {
    display: flex;
    // 修改主轴方向；row（默认值，水平方向）column：垂直方向
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .url {
      width: 500px;
      height: 300px;
    }
    .content {
      color: #cacdd1;
    }
  }
  .box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      display: flex;
      align-items: center;
      width: 49%;
      border: 1px solid #eee;
      margin-bottom: 30px;
      padding: 20px;
      .item-name {
        font-size: 18px;
      }
      .item-bottom {
        margin-bottom: 5px;
      }
      .item-img {
        width: 50px;
        height: 50px;
        margin-right: 40px;
      }
      .item-pay {
        color: #2d8cf0;
        border: 1px solid #2d8cf0;
        height: 32px;
        line-height: 32px;
        border-radius: 2px;
        padding: 0 10px;
        cursor: pointer;
      }
    }
  }
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .myApi {
    padding: 15px 12px;

    .title {
      font-size: 20px;
      margin-bottom: 15px;
    }

    .noData {
      .url {
        width: 200px;
        height: 120px;
      }
      .content {
        font-size: 14px;
      }
    }

    .box {
      .item {
        width: 100%;
        margin-bottom: 15px;
        padding: 12px;
        flex-wrap: wrap;

        .item-img {
          width: 40px;
          height: 40px;
          margin-right: 15px;
        }

        .item-name {
          font-size: 15px;
        }

        .item-bottom {
          font-size: 12px;
          margin-bottom: 3px;
        }
      }
    }
  }
}
</style>
